import MaintenanceFeeLTR from '../../../../../pages/vip/features/maintenance-feel-ltr/maintenance-fee-ltr';

export default MaintenanceFeeLTR;
